import { render, staticRenderFns } from "./DescriptionTerm.vue?vue&type=template&id=c18519ba&"
import script from "./DescriptionTerm.vue?vue&type=script&lang=js&"
export * from "./DescriptionTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports